import format from 'date-fns/format';
import { useEffect, useMemo, useState } from 'react';
import { BsPlusLg } from 'react-icons/bs';
import { FormatNumber } from 'utils/helpers';

interface PropsItem {
  title?: string;
  data: any;
  type?: string;
}

const CoinLabel: any = {
  uau: 'Arrasou',
  mandou: 'Top',
  valeu: 'Curti',
};

const BehaviorLabel: any = {
  colaboracao: 'Colaboração',
  inovacao: 'Inovação',
  foco: 'Foco no Cliente',
  resolutividade: 'Proatividade',
  lideranca: 'Liderança Engajadora',
};

export function Summary(props: PropsItem) {
  const { title, data, type } = props;

  function translateTitle(item: any) {
    if (item?.log?.attributes?.campanha) {
      return (
        <>
          <p className="block text-base text-[#F0F3FC] mb-3">Você participou {`${item.log.attributes.campanha}`}</p>
          <p className="text-[#F0F3FC] text-sm font-thin m-0">#Campanha</p>
        </>
      );
    } else if (item?.log?.action === 'Entrou por convite') {
      return (
        <>
          <p className="block text-base text-[#F0F3FC] mb-3">
            Convide seus amigos - Convite aceito por{' '}
            <span className="text-electric-blue capitalize">{item.extra.target_nome_guerra}</span>
          </p>
          <p className="text-[#F0F3FC] text-sm font-thin m-0">#Ação</p>
        </>
      );
    } else if (item?.log?.attributes?.type === 'challenge') {
      return (
        <>
          <p className="block text-base text-[#F0F3FC] mb-3">{item?.log?.attributes?.title}</p>
          <p className="block text-base text-[#F0F3FC] mb-3">
            {' '}
            Total de desafios concluídos: {item?.log?.attributes?.totalCompleted}/{item?.log?.attributes?.total}
          </p>
          <p className="text-[#F0F3FC] text-sm font-thin m-0">#Desafio</p>
        </>
      );
    }
  }

  return useMemo(() => {
    function renderRecognition() {
      return (
        <>
          <div className="flex flex-col border-t border-[#072E4A] mt-8 pt-8">
            <h3 className="block text-yellow text-base mb-6" tabIndex={0}>
              {title}
            </h3>
            {data.map((item: any, index: number) => (
              <div
                className={`flex flex-col items-start lg:items-center lg:flex-row justify-between ${
                  index > 0 ? 'border-t border-[#072E4A] mt-8 pt-8' : ''
                }`}
                key={index}
                tabIndex={0}
              >
                <div className="mb-3 lg:mb-0">
                  <span className="block font-light text-base text-[#5E7A90] mb-2">
                    {format(new Date(item.time), 'dd/MM/yyyy')} às {format(new Date(item.time), 'HH:mm')}
                  </span>
                  <p className="block text-base text-[#F0F3FC] mb-3">
                    {item.sender_nome_guerra} ({item.sender}) te enviou:
                  </p>
                  <p className="text-[#F0F3FC] text-sm font-thin m-0">
                    {CoinLabel[item.coin]} + {BehaviorLabel[item.behavior]}
                  </p>
                </div>
                <div>
                  <p className="text-xl font-normal text-electric-blue flex items-center space-x-1">
                    <BsPlusLg className="text-xl" size={17} /> <span>{FormatNumber(item.total, false)} Pts</span>
                  </p>
                </div>
              </div>
            ))}
          </div>
        </>
      );
    }

    function renderRealization() {
      return (
        <>
          <div className="flex flex-col border-t border-[#072E4A] mt-8 pt-8">
            <h3 className="block text-yellow text-base mb-6" tabIndex={0}>
              {title}
            </h3>
            {data.map((item: any, index: number) => (
              <div
                className={`flex flex-col items-start lg:items-center lg:flex-row justify-between ${
                  index > 0 ? 'border-t border-[#072E4A] mt-8 pt-8' : ''
                }`}
                key={index}
              >
                <div className="mb-3 lg:mb-0">
                  <span className="block font-light text-base text-[#5E7A90] mb-2">
                    {format(new Date(item.time), 'dd/MM/yyyy')} às {format(new Date(item.time), 'HH:mm')}
                  </span>
                  {item.type === 'entrega_equipe' && (
                    <>
                      <p className="block text-base text-[#F0F3FC] mb-3">
                        Participação em Realização Destaque - {item.cicloTitle} - Fase {item.faseTitle}
                      </p>
                      <p className="text-[#F0F3FC] text-sm font-thin m-0">
                        Nome da realização: {item.titulo} | {item.participacao}% de atuação
                      </p>
                    </>
                  )}

                  {item.type === 'entrega_gestor' && (
                    <>
                      <p className="block text-base text-[#F0F3FC] mb-3">
                        Validação das Realizações Destaque - {item.cicloTitle} - Fase {item.fase}
                      </p>
                      <p className="text-[#F0F3FC] text-sm font-thin m-0">Nome da realização: {item.task.title}</p>
                    </>
                  )}

                  {item.type === 'feedback_gestor' && (
                    <>
                      <p className="block text-base text-[#F0F3FC] m-0">
                        Feedback enviado nas Realizações Destaque avaliadas - {item.cicloTitle} - Fase {item.fase}
                      </p>
                    </>
                  )}

                  {item.type === 'bonus_colaboracao_gestor' && (
                    <>
                      <p className="block text-base text-[#F0F3FC] m-0">
                        Bônus Colaboração {'('}IN 403-1 item 7.2.6.5.3.15.10{')'} - {item.cicloTitle} - Fase {item.fase}
                      </p>
                    </>
                  )}

                  {item.type === 'pontos_bonus_prazo_gestor' && (
                    <>
                      <p className="block text-base text-[#F0F3FC] m-0">
                        Bônus por realizar as validações das realizações dentro do prazo - {item.cicloTitle} - Fase {item.fase}
                      </p>
                    </>
                  )}
                </div>
                <div>
                  <p className="text-xl font-normal text-electric-blue flex items-center space-x-1">
                    <BsPlusLg className="text-xl" size={17} /> <span>{FormatNumber(item.total, false)} Pts</span>
                  </p>
                </div>
              </div>
            ))}
          </div>
        </>
      );
    }

    function renderAction() {
      return (
        <>
          <div className="flex flex-col border-t border-[#072E4A] mt-8 pt-8">
            <h3 className="block text-yellow text-base mb-6">{title}</h3>
            {data.map((item: any, index: number) => (
              <div
                className={`flex flex-col items-start lg:items-center lg:flex-row justify-between ${
                  index > 0 ? 'border-t border-[#072E4A] mt-8 pt-8' : ''
                }`}
                key={index}
                tabIndex={0}
                aria-label={``}
              >
                <div className="mb-3 lg:mb-0">
                  <span className="block font-light text-base text-[#5E7A90] mb-2">
                    {format(new Date(item.time), 'dd/MM/yyyy')} às {format(new Date(item.time), 'HH:mm')}
                  </span>
                  {translateTitle(item)}
                </div>
                <div>
                  <p className="text-xl font-normal text-electric-blue flex items-center space-x-1">
                    <BsPlusLg className="text-xl" size={17} /> <span>{FormatNumber(item.total, false)} Pts</span>
                  </p>
                </div>
              </div>
            ))}
          </div>
        </>
      );
    }

    function renderDefault() {
      return <></>;
    }

    if (!type && !data && !title) return null;

    switch (type) {
      case 'recognition':
        return renderRecognition();
      case 'realization':
        return renderRealization();
      case 'action':
        return renderAction();
      default:
        return renderDefault();
    }
  }, [title, data, type]);
}
